import {
  OnInit, Component, ViewEncapsulation, Injectable,
} from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';


@Injectable()
export class checkAuth implements OnInit {

  constructor(private _router:Router) {
      Swal.mixin({heightAuto: false});
  }

  ngOnInit() {
  }

  checkMenusForAuthority(ScreenCode :string){
    var Menus = JSON.parse(localStorage.getItem('DashboardMenus'));
    var IsExist = false;
    Menus.forEach((Item: any) => {
      var Menu;
      Menu = (Item.SubMenus.find(x => x.ScreenCode == ScreenCode));
      if (Menu !== null && Menu !== undefined) {
        IsExist = true;
      }
    });
    if (!IsExist){
      this._router.navigate([`/UnauthorizedAccess`]);
    }
    return IsExist;
  }
}
